import React from "react"
import { useTranslation } from "react-i18next"
import { Rating } from ".."
export default ({
  openCommentForm,
  data,
  // handleSetComment,
  selectedRate,
  stars,
  averageRate,
}) => {
  const { t } = useTranslation()
  const strokeWidth = (idx) => {
    if (stars[idx]) {
      return `${Math.round((stars[idx] / data?.comments.length) * 100)}%`
    }
    return "0%"
  }

  return (
    <div className="">
      <div className="text-xl font-medium text-primary-text-color">
        {t("comment-done-works")}
      </div>
      <div className="flex flex-col items-start w-full py-4 mb-3 xl:flex xl:items-center xl:flex-row xl:justify-between lg:flex lg:items-center lg:flex-row lg:justify-between md:flex md:flex-col md:items-start sm:flex sm:flex-col sm:items-start lg:py-0 md:py-4 sm:py-4">
        <Rating commonRate={selectedRate} />
        <button
          className="px-20 py-4 lg:my-0 md:my-7 sm:my-7 my-7 lg:w-auto md:w-full sm:w-full w-full text-white bg-[color:var(--custom-primary)] flex justify-center items-center text-lg rounded-md"
          onClick={openCommentForm}
        >
          {t("leave-comment")}
        </button>
      </div>

      <div className="flex items-center justify-between w-full h-full py-4 mt-4 lg:py-6">
        <div className="flex flex-col items-start justify-center w-1/5">
          <h1 className="text-6xl font-normal lg:text-8xl md:text-6xl sm:text-6xl text-primary-text-color">
            {averageRate > 0 ? averageRate.toFixed(1) : 0}
          </h1>{" "}
          <Rating commonRate={averageRate} handleRate={() => {}} />
        </div>
        <div className="flex flex-col items-start justify-start w-4/5 gap-2 ml-10 text-black lg:ml-0 md:ml-10 sm:ml-10">
          {Array.from({ length: 5 }).map((_, index) => (
            <div
              className="flex items-center justify-center w-full gap-2 text-base font-medium"
              key={index}
            >
              <span>{5 - index}</span>
              <div className="w-full rounded-full h-3 lg:h-[18px] bg-[#c2c2c2]">
                <div
                  style={{
                    width: strokeWidth(5 - index),
                  }}
                  className={`h-full rounded-full bg-[#1D395A]`}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
